import { AdminCheckoutExperienceScreen } from '@features/admin/ui/AdminCheckoutExperienceScreen'

export function CheckoutExperiencePage() {
  return <AdminCheckoutExperienceScreen />
}
